<template>
  <span>
    <div
      v-for="(item, index) in radios"
      class="radio d-flex flex-column align-items-center"
      :key="index"
    >
      <input
        type="radio"
        :name="name + '[]'"
        :value="item.value"
        :id="name + '_' + index"
        v-model="checked"
      />
      <label :for="name + '_' + index">{{ item.label }}</label>
    </div>
  </span>
</template>

<script>
export default {
  props: ["items", "name"],
  data() {
    return {
      ckecked: '',
    };
  },
  created() {
    this.radios = JSON.parse(this.items);
    this.getChecked();
  },
  methods: {
    getChecked() {
      this.radios.filter((rad) => {
        if (rad.checked === "checked") {
          this.checked = rad.value;
        }
      });
    },
  },
};
</script>
